<template>
    <a-spin :spinning="spinning" tip="Loading...">
        <div class="card mb-3">
            <div class="row no-gutters">
                <div class="col-md-12" style="border-right: 1px solid #e0e0e0">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-4">
                            <base-input alternative="" label="Select User Group">
                                <a-select mode="multiple" v-model="inputUserGroup" showSearch allowClear placeholder="All User Groups" optionFilterProp="children" style="width: 100%" :filterOption="filterOption">
                                    <a-select-option v-for="option in userGroupOptions" :key="option.id" :value="option.id">
                                        {{option.name}} ({{option.code}})
                                    </a-select-option>
                                </a-select>
                            </base-input>
                            </div>
                        </div>

                        <div class="row mt-3">
                            <div class="col-md-12">
                                <button class="btn btn-sm btn-success float-right" style="border-radius: 24px; border:0px; width: 20%;" @click.prevent="generateExcel">
                                    Generate Report in Excel
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </a-spin>
</template>
    
<script>
    import HTTPRequest from '../../controllers/httpRequest.js'
    import secureStorage from '../../controllers/secureStorage';
    import reportUtils from '../../components/reportUtils'
    import moment from 'moment';
    import * as ExcelJS from "exceljs";
    import { saveAs } from "file-saver";
    import _ from 'lodash';
    
    import {
        mapState,
        mapActions
    } from 'vuex'
    
    var component_x;
    
    export default {
        data() {
            return {
                spinning: false,
                inputUserGroup: [],
                userGroupOptions: [],
                currDate: moment().format("L_LT").split(":").join(";"),
                reportData: [],
                groupedReportData: []
            }
        },
        mounted: async function () {
        component_x = this;
            // Load user groups
            var userGroups = await HTTPRequest.getRequest(component_x.endPoint + "user_groups/get_valid_user_groups", null);
            component_x.userGroupOptions = userGroups;
            component_x.sort(component_x.userGroupOptions);
        },
        computed: {
            ...mapState(['currentProfile', 'endPoint']),
        },
        methods: {
            moment,
            filterOption(input, option) {
                return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
            },
            sort(data) {
                data.sort(function (a, b) {
                return a.name.localeCompare(b.name);
                });
            },
            formatAccessRights(accessRights) {
                if (!accessRights) return 'None';
                
                const rights = accessRights.split(',').filter(r => r);
                if (rights.length === 0) return 'None';
                
                const accessMap = {
                    'V': 'View',
                    'A': 'Add',
                    'W': 'Edit',
                    'D': 'Delete',
                    'P': 'Post',
                    'C': 'Confirm',
                    'T': 'Print',
                    'S': 'Supervise',
                    'X': 'Sensitive Info',
                    'Z': 'Access Cost',
                    'Y': 'Access Price',
                    'I': 'Import',
                    'E': 'Export',
                    'N': 'Scan',
                    'Q': 'Download',
                    'R': 'Wipe Data',
                    'G': 'Configure'
                };
                
                return rights.map(r => accessMap[r] || r).join(', ');
            },
            formatDate(dateString) {
                if (!dateString) return '';
                return moment(dateString).format('MM/DD/YYYY hh:mm A');
            },
            async generateExcel() {
                this.spinning = true;
                this.reportData = [];
                this.groupedReportData = [];
                
                let parameters = {
                "user_group_id": this.inputUserGroup.toString()
                };

                try {
                    var response = await HTTPRequest.getRequest(this.endPoint + 'user_group_access_reports?', parameters);

                    if (response.error) {
                        reportUtils.openNotificationWithIcon(component_x, 'error', response.error);
                        this.spinning = false;
                        return;
                    }

                    if (response.length > 0 && response[0].report_details.length > 0) {
                        this.reportData = response[0].report_details;
                        this.processReportData();
                        this.createExcelReport();
                    } else {
                        reportUtils.openNotificationWithIcon(component_x, 'warning', 'No Data.');
                    }
                } catch (error) {
                    reportUtils.openNotificationWithIcon(component_x, 'error', 'An error occurred while generating the report.');
                    console.error(error);
                }

                this.spinning = false;
            },
            processReportData() {
                // group the data by user group
                const groupedData = _.groupBy(this.reportData, 'user_group_id');

                this.groupedReportData = Object.keys(groupedData).map(groupId => {
                const group = groupedData[groupId];
                    return {
                        user_group_id: group[0].user_group_id,
                        user_group_code: group[0].user_group_code,
                        user_group_name: group[0].user_group_name,
                        status: group[0].status,
                        modules: group.map(item => ({
                            // module_code: item.module_code,
                            module_name: item.module_name,
                            access_right: item.access_right,
                            require_reason: item.require_reason,
                            require_remarks: item.require_remarks,
                            created_by: item.created_by,
                            created_at: item.created_at,
                            updated_by: item.updated_by,
                            updated_at: item.updated_at
                        }))
                    };
                });
            },
            createExcelReport() {
                const workbook = new ExcelJS.Workbook();
                workbook.created = new Date();
                workbook.modified = new Date();
                const sheet = workbook.addWorksheet("User Group Access Report", {
                    pageSetup: { paperSize: 9 }
                });

                // headers
                const data_starts_at_row = 8;

                sheet.getRow(4).values = ["User Group Access Report"];
                sheet.getRow(5).values = [`Generated on: ${moment().format('MM/DD/YYYY hh:mm A')}`];
                sheet.getRow(6).values = [`Selected User Group: ${this.inputUserGroup.length > 0 ? 
                    this.inputUserGroup.map(id => {
                        const group = this.groupedReportData.find(g => g.user_group_id === id);
                        return group ? `${group.user_group_name} (${group.user_group_code})` : id;
                    }).join(', ')
                    : 'All User Groups'}`];
                sheet.getRow(7).values = [`Generated by: ${secureStorage.getItem("email") || 'System'}`];

                // column headers
                sheet.getRow(data_starts_at_row).values = [
                    "User Group ID",
                    "User Group Code",
                    "User Group Name",
                    "Status",
                    // "Module Code",
                    "Module Name",
                    "Access Rights",
                    "Created By",
                    "Created At",
                    "Updated By",
                    "Updated At"
                ];

                sheet.columns = [
                    { key: "user_group_id", width: 15 },
                    { key: "user_group_code", width: 20 },
                    { key: "user_group_name", width: 25 },
                    { key: "status", width: 10 },
                    // { key: "module_code", width: 15 },
                    { key: "module_name", width: 35 },
                    { key: "access_rights", width: 80 },
                    { key: "created_by", width: 15 },
                    { key: "created_at", width: 20 },
                    { key: "updated_by", width: 15 },
                    { key: "updated_at", width: 20 }
                ];

                // Add data rows
                const rowDatas = [];

                this.groupedReportData.forEach(group => {
                    group.modules.forEach(module => {
                        let accessRights = this.formatAccessRights(module.access_right);

                        // append require_reason and require_remarks if they are true
                        if (module.require_reason === 1 || module.require_reason === true) {
                            accessRights += ", Require Reason";
                        }
                        if (module.require_remarks === 1 || module.require_remarks === true) {
                            accessRights += ", Require Remarks";
                        }

                        rowDatas.push({
                            user_group_id: group.user_group_id,
                            user_group_code: group.user_group_code,
                            user_group_name: group.user_group_name,
                            status: group.status,
                            module_id: module.module_id,
                            module_code: module.module_code,
                            module_name: module.module_name,
                            access_rights: accessRights,
                            created_by: module.created_by,
                            created_at: this.formatDate(module.created_at),
                            updated_by: module.updated_by,
                            updated_at: this.formatDate(module.updated_at)
                        });
                    });
                });

                sheet.addRows(rowDatas);

                sheet.getRow(4).font = { bold: true, size: 16 };
                sheet.getRow(4).height = 20;
                sheet.getRow(data_starts_at_row).font = { bold: true };

                sheet.eachRow(function (Row, rowNum) {
                    if (rowNum >= data_starts_at_row) {
                        Row.eachCell(function (Cell, cellNum) {
                            if (rowNum == data_starts_at_row) {
                                Cell.alignment = {
                                horizontal: 'center'
                                }
                            } else {
                                Cell.alignment = {
                                vertical: 'middle',
                                horizontal: 'left'
                                }
                            }
                        })
                    }
                });

                workbook.xlsx.writeBuffer().then(function (buffer) {
                    const blob = new Blob([buffer], { type: "application/xlsx" });
                    saveAs(blob, `UserGroupAccessReport.xlsx`);
                });
            }
        }
    };
</script>

<style>
    .table th, .table td {
        vertical-align: middle;
    }
</style>